// router.ts
import { createRouter } from "@tanstack/react-router";

import NotFound from "./components/dashboard/not-found";
import { routeTree } from "./routeTree.gen";

export const router = createRouter({
	routeTree,
	defaultPreload: "intent",
	defaultPendingComponent: () => (
		<div className="flex flex-col items-center justify-center gap-4 h-screen w-screen overflow-hidden">
			<div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
		</div>
	),
	defaultNotFoundComponent: NotFound
});
